import React, { Component } from 'react';
import JobsDashboard from './Commons/JobsDashboard.js';

export default class IWTDashboard extends Component {
	render() {
		return (
			<div>
				<JobsDashboard operationName={'IWT'} operationType={'INTER_WAREHOUSE_TRANSFER'} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/IWTDashboard.js